'use-strict';

/* @ngInject */
export default function InfoBoxController(
  $rootScope,
  $scope,
) {
  $scope.overlay = false;

  $scope.hideOveray = () => {
    $scope.overlay = false;
  };

  $scope.showOverlay = () => {
    $scope.overlay = true;
  };
}
